"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AuthProvider_1 = require("../AuthProvider");
const hookrouter_1 = require("hookrouter");
exports.SecurePage = ({ children }) => {
    const auth = AuthProvider_1.useAuth();
    react_1.useEffect(() => {
        if (!auth.isAuthenticated && !auth.isChecking) {
            hookrouter_1.navigate('/login', true);
        }
    }, [auth.isAuthenticated]);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
